import { render } from "./packages-list.vue?vue&type=template&id=5ade2ffe"
import script from "./packages-list.vue?vue&type=script&lang=js"
export * from "./packages-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__